export default __webpack_public_path__ + "hero-mobile-5c8657a6b70caaf22da000937d833706.digested.webp";